import { render, staticRenderFns } from "./ProgramsView.vue?vue&type=template&id=45b4c7a7"
import script from "./ProgramsView.vue?vue&type=script&lang=js"
export * from "./ProgramsView.vue?vue&type=script&lang=js"
import style0 from "./ProgramsView.vue?vue&type=style&index=0&id=45b4c7a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports